import { GridColumnProps } from './ColumnsBase';
import { getCatClassColDef } from '../helpers/getCatClassColDef';

const ColumnsPreSelect = ({
  gridGroupingValues,
}: GridColumnProps) => {
  return getCatClassColDef(gridGroupingValues);
};

export default ColumnsPreSelect;
